import { z } from 'zod';
export const paginationQueryParamsSchema = z.object({
    page: z
        .string()
        .regex(/^[1-9]\d*$/, 'Page must be a positive integer')
        .optional(),
    limit: z
        .string()
        .regex(/^[1-9]\d*$/, 'Limit must be a positive integer')
        .optional(),
});
export const createPaginatedSchema = (item) => z.object({
    has_next_page: z.boolean(),
    data: z.array(item),
    page: z.number().min(1),
});
export const createCrmPaginatedSchema = (item) => z.object({
    meta: z
        .object({
        'total-pages': z.number().min(1).optional(),
        'records-on-this-page': z.number().min(1).optional(),
        message: z.string().optional(),
    })
        .optional(),
    data: z.array(item),
});
